import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
	selector: 'app-avg-daily-usage',
	templateUrl: './avg-daily-usage.component.html',
	styleUrls: ['./avg-daily-usage.component.css']
})
export class AvgDailyUsageComponent implements OnChanges{

	@Input() report: any = {};
	@Input() devices: any = {};
	@Input() period: string ='';
	@Input() weeksOfOperation: number = 0;

	hourUsage = { inUse: 0, charge: 0, idle: 0 };
	ampUsage = { inUse: 0, charge: 0 };
	hourGradient = '';
	ampGradient = '';
	ampReturnPercent = 0;
	ampBars: any[] = [];
	
	ngOnChanges(changes: SimpleChanges) {
		if (changes['report'] || changes['period']) {
			this.mapReport(this.report, this.period);
		}
	}

	mapReport(report: any, period: string) {
		const hourData = report?.hourUsagePerformance?.[period];
		const ampData = report?.ampHourPerformance?.[period];

		if (!hourData || !ampData) 
			return;

		this.hourUsage = {
			inUse: hourData.inUse?.percent || 0,
			charge: hourData.charge?.percent || 0,
			idle: hourData.idle?.percent || 0
		};

		this.ampUsage = {
			inUse: ampData.inUseAH?.percent || 0,
			charge: ampData.chargeAH?.percent || 0
		};

		const inUse = this.hourUsage.inUse;
		const charge = this.hourUsage.charge;
		const idle = this.hourUsage.idle;

		const total = inUse + charge + idle || 1;

		const inUseP = (inUse / total) * 100;
		const chargeP = (charge / total) * 100;

		this.hourGradient = `conic-gradient(#3f51b5 0% ${inUseP}%, #3fa56a ${inUseP}% ${inUseP + chargeP}%, #9e9e9e ${inUseP + chargeP}% 100%)`;

		this.ampBars = [
			{ label: 'InUse Ah', value: ampData.inUseAH?.value || 0, percent: ampData.inUseAH?.percent || 0, color: 'blue' },
			{ label: 'Charge Ah', value: ampData.chargeAH?.value || 0, percent: ampData.chargeAH?.percent || 0, color: 'green' },
			{ label: 'Max Available Ah', value: ampData.maxAvailableAH?.value || 0, percent: ampData.maxAvailableAH?.percent || 0, color: 'orange' }
		];

		this.ampGradient = `conic-gradient(
			#3f51b5 0% ${this.ampUsage.inUse}%,
			#3fa56a ${this.ampUsage.inUse}% ${this.ampUsage.inUse + this.ampUsage.charge}%
		)`;
		this.ampReturnPercent = ampData.returnedPercent;
	}
}
